import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function Testimonials() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-361" data-mp="3fy2ytulpdq2z">
      <div className="mx-auto max-w-6xl px-4" data-id="element-362" data-mp="3b0udxm9677y1">
        <SectionHeading eyebrow="What Colleagues Are Saying" title="Dental Students and Professionals Are Bringing More Structure to Their Case Reviews" data-id="element-363" data-mp="3b01gxd00jwt3" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-364" data-mp="31yv0f3xd6lzu">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_10px_40px_-25px_rgba(16,42,76,0.35)] sm:p-8" data-id="element-365" data-mp="2x1upofpkkv2e">
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-366" data-mp="2s3t5frgeqppc">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-367" data-mp="qa3qrciu5drb" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[17px] leading-relaxed text-ink" data-id="element-368" data-mp="h4ddqnyh7s58">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-369" data-mp="m6m55fvpam58">
                <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-accentSoft" loading="lazy" data-id="element-370" data-mp="78tub113mlxd" />
                <div data-id="element-371" data-mp="c8ol74kvjbif">
                  <p className="font-bold text-ink" data-id="element-372" data-mp="zwpqm4mrabtm">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-373" data-mp="zyiwhhpjos0k">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-374" data-mp="q5la30hfmiwo">
          <CtaButton label="I Want to Organize My Cases Like This Too" data-id="element-375" data-mp="q6cvxjl8929r" />
        </div>
      </div>
    </section>;
}